
import GameUtil from "../../../../utility/game_util";

const { ccclass, property } = cc._decorator;
@ccclass
export default class DailySignItem extends cc.Component {

    @property(cc.Sprite)
    spriteAwardIcon: cc.Sprite = null

    @property(cc.Label)
    labelCount: cc.Label = null

    @property(cc.Node)
    nodeGetted: cc.Node = null

    @property(cc.Node)
    nodeChip: cc.Node = null

    @property(cc.Node)
    nodeGold: cc.Node = null

    show(show: boolean, data?: any): boolean{
        let self = this
        this.node.active = !!show
        if(show){
            this.node.active = data && data.awardList && data.awardList.length > 0
            if(!data || !data.awardList || data.awardList.length < 1){
                return false
            }
            this.nodeGetted.active = !!data.isFinish                   
            this.fillAward(data)
        }
        return true
    }


    protected fillAward(data){
        let awardData = data.awardList[0]
        this.labelCount.string = GameUtil.currencyFormatting(awardData.amount)
        this.nodeChip.active = awardData.activityAmountType == 5
        this.nodeGold.active = awardData.activityAmountType == 6
        this.spriteAwardIcon.node.active = awardData.activityAmountType != 6 && awardData.activityAmountType != 6
        if(awardData.activityAmountType != 6 && awardData.activityAmountType != 6){
            //自定义icon
        }
    }
}